import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postEmployees({ body }) {
  return BaseService.post(REST.EMPLOYEES, body);
}

function getEmployees(params) {
  return BaseService.get(REST.EMPLOYEES, {
    params: paramsFilter({ params }),
  });
}

function putEmployees({ body, id }) {
  return BaseService.put(REST.EMPLOYEES_ID(id), body);
}

function deleteEmployees({ id }) {
  return BaseService.delete(REST.EMPLOYEES_ID(id));
}

export default {
  putEmployees,
  postEmployees,
  getEmployees,
  deleteEmployees,
};
